module.exports = __webpack_public_path__ + "static/media/NAR-CAKE.a1d0b313.svg";